<template>
    <div class="Toggle">
        <div class="Toggle-switch">
            <div v-for="tab of tabs"
                 class="Toggle-switch-title"
                 :key="tab.name"
                 :class="{ active: tab.isActive }"
                 @click="selectTab(tab)"
            >
                {{ tab.title }}
            </div>
            <div class="Toggle-active-label"
                 :style="activeLabelStyle">
            </div>
        </div>
        <slot/>
    </div>
</template>

<script>
    import { EventListenerMixin } from '@/mixins/EventListenerMixin';
    const TAB_WIDTH = 110;

    export default {
        name: 'Toggle',

        props: {
            activeTab: {
                type: String,
                required: true
            }
        },

        mixins: [EventListenerMixin('resize', 'resizeListener')],

        data() {
            return {
                tabs: [],
                elWidth: 0,
                mobile: false,
                changed: false
            }
        },

        computed: {
            activeLabelStyle() {
                const activeTabIndex = this.tabs && this.tabs.findIndex(tab => tab.isActive);

                if (activeTabIndex !== null) {
                    if (activeTabIndex === 0) {
                        return this.$el && {
                            transform: this.mobile
                                ? `translateX(${activeTabIndex * this.elWidth / 2 + 5}px)`
                                : `translateX(${activeTabIndex * TAB_WIDTH}px)`
                        }
                    } else {
                        return this.$el && {
                            transform: this.mobile
                                ? `translateX(${activeTabIndex * this.elWidth / 2 - 5}px)`
                                : `translateX(${activeTabIndex * TAB_WIDTH}px)`
                        }
                    }
                }
            }
        },

        watch: {
            activeTab: {
                async handler(value) {
                    await this.$nextTick();
                    if (value) {
                        const activeTab = this.tabs.find(tab => tab.isActive);
                        const tab = this.tabs.find(tab => tab.title === value);
                        if (!activeTab || activeTab.title !== value) {
                            this.selectTab(tab);
                        }
                    }
                    else if (!this.changed) {
                        const firstTab = this.tabs[0];
                        this.selectTab(firstTab);
                    }
                    else {
                        this.tabs.forEach(tab => tab.isActive = false);
                    }
                    this.changed = true;
                },

                immediate: true
            }
        },

        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = tab.title === (selectedTab && selectedTab.title);
                });
                const activeTab = this.tabs.find(tab => tab.isActive);
                activeTab && this.$emit('changed', activeTab.title);
            },

            resizeListener() {
                this.mobile = window.innerWidth < 520;
                this.elWidth = this.$el.getBoundingClientRect().width;
            }
        },

        mounted() {
            this.tabs = this.$children;
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/colors";

    @mixin switchTransition() {
        transition: all .7s ease-in-out;
    }

    .Toggle {
        &-switch {
            position: relative;
            height: 45px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 40px;
            border: solid 2px $ComplementaryBgTxtDarker;
            background-color: $ComplementaryBackgroundLightGrey;

            &-title {
                z-index: 1;
                height: 100%;
                width: 110px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 3px;
                margin-right: 3px;
                text-align: center;
                cursor: pointer;
                font-size: 14px;
                line-height: 1.71;
                letter-spacing: -0.1px;
                color: $WhiteGrey;
                @media screen and (max-width: 520px ) {
                    width: 50%;
                }
            }

            .active {
                @include switchTransition;
                color: $White;
            }
        }

        &-active-label {
            @include switchTransition;
            position: absolute;
            top: 3px;
            left: 2px;
            width: 49%;
            height: 36px;
            border-radius: 50px;
            color: $White;
            background-color: $Blue;

            @media screen and (max-width: 520px) {
                width: 50%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/controls/Toggle.vue